import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerSections = [
    {
      title: 'Platform',
      links: [
        { name: 'How It Works', href: '/how-it-works', isRoute: true },
        { name: 'Why Join', href: '/why-join', isRoute: true },
        { name: 'Petitioner DAO', href: '/dao', isRoute: true },
        { name: 'Launch dApp', href: 'https://app.petition.io', isRoute: false, external: true }
      ]
    },
    {
      title: 'Resources',
      links: [
        { name: 'Impact', href: '/impact', isRoute: true },
        { name: 'Merch', href: '/merch', isRoute: true },
        { name: 'FAQ', href: '/faq', isRoute: true },
        { name: 'Contact', href: '/contact', isRoute: true }
      ]
    },
    {
      title: 'Legal',
      links: [
        { name: 'Terms of Service', href: '#' },
        { name: 'Privacy Policy', href: '#' },
        { name: 'Smart Contract', href: '#' },
        { name: 'Etherscan', href: '#' }
      ]
    }
  ];

  const socialLinks = [
    { name: 'X (Twitter)', icon: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z', href: 'https://x.com/PetitionIO' },
    { name: 'LinkedIn', icon: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z', href: 'https://www.linkedin.com/company/petitionio' },
    { name: 'Facebook', icon: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z', href: 'https://www.facebook.com/61582117326612/' },
    { name: 'Instagram', icon: 'M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z', href: 'https://www.instagram.com/petition.io/' },
    { name: 'Farcaster', icon: 'M 20.662109 4.0898438 L 20.662109 5.3964844 C 17.702109 5.3964844 15.296875 7.8017187 15.296875 10.761719 L 15.296875 12.070312 L 12.033203 12.070312 L 12.033203 10.761719 C 12.033203 7.8017187 9.6269531 5.3964844 6.6679688 5.3964844 L 6.6679688 4.0898438 C 10.371969 4.0898438 13.380859 7.0987656 13.380859 10.802734 L 13.380859 19.910156 L 15.382812 19.910156 L 15.382812 10.802734 C 15.382813 7.0987656 18.391703 4.0898438 22.095703 4.0898438 L 20.662109 4.0898438 z M 10.697266 14.007812 L 10.697266 19.912109 L 8.6972656 19.912109 L 8.6972656 14.007812 L 10.697266 14.007812 z M 18.630859 14.007812 L 18.630859 19.912109 L 16.630859 19.912109 L 16.630859 14.007812 L 18.630859 14.007812 z', href: 'https://farcaster.xyz/petitionio' },
  ];

  return (
    <footer className="text-white" style={{ background: 'linear-gradient(135deg, #1e3a8a 0%, #1e293b 50%, #0f172a 100%)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Logo & Description */}
          <div className="lg:col-span-2">
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="flex items-center space-x-3 mb-4"
            >
              <img src="/images/petitionlogo4Dark.png" alt="Petition.io" className="h-10 w-auto" />
              <span className="text-2xl font-bold text-white">Petition.io</span>
            </motion.div>
            <p className="text-white/80 mb-6 leading-relaxed">
              The world's first fully decentralized petition platform. Empowering voices through blockchain technology.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social, idx) => (
                <motion.a
                  key={idx}
                  whileHover={{ scale: 1.2, y: -2 }}
                  whileTap={{ scale: 0.9 }}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full flex items-center justify-center transition-all"
                  style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)' }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#3498db'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)'}
                  aria-label={social.name}
                >
                  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d={social.icon} />
                  </svg>
                </motion.a>
              ))}
            </div>
          </div>

          {/* Footer Sections */}
          {footerSections.map((section, idx) => (
            <div key={idx}>
              <h4 className="text-lg font-bold mb-4 text-white">{section.title}</h4>
              <ul className="space-y-3">
                {section.links.map((link, linkIdx) => (
                  <li key={linkIdx}>
                    {link.isRoute ? (
                      <Link to={link.href}>
                        <motion.span
                          whileHover={{ x: 5 }}
                          className="text-white/70 hover:text-white transition-colors inline-block"
                        >
                          {link.name}
                        </motion.span>
                      </Link>
                    ) : (
                      <motion.a
                        whileHover={{ x: 5 }}
                        href={link.href}
                        target={link.external ? '_blank' : undefined}
                        rel={link.external ? 'noopener noreferrer' : undefined}
                        className="text-white/70 hover:text-white transition-colors"
                      >
                        {link.name}
                      </motion.a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 text-center text-white" style={{ borderTop: '1px solid rgba(255, 255, 255, 0.2)', marginTop: '2rem' }}>
          <p className="mb-2 text-white/90">&copy; {currentYear} Petition.io. Built on Ethereum. Owned by the people.</p>
          <p className="text-sm text-white/70">All petitions and signatures are permanently recorded on the blockchain.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
